import { Component, computed, ElementRef, inject, signal, viewChild } from '@angular/core';
import { SelectedAttributeService } from '../../../services/selected-attribute.service';
import { CheckoutService } from '../../../services/checkout.service';
import { assert } from 'src/app/utils/assert.util';
import { ConfiguredItemService } from 'src/app/services/configured-item/configured-item.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics/google-analytics.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { Navigation2Service } from '../../../services/navigation2.service';
import { ShareService } from 'src/app/services/share/share.service';

@Component({
  selector: 'app-share-section',
  templateUrl: './share-section.component.html',
  styleUrl: './share-section.component.scss'
})
export class ShareSectionComponent {
  private clipBoard = inject(Clipboard);
  private navigationService = inject(Navigation2Service);
  private googleAnalyticsService = inject(GoogleAnalyticsService);
  private configuredItemService = inject(ConfiguredItemService);
  private checkoutService = inject(CheckoutService);
  private selectedAttributeService = inject(SelectedAttributeService);
  private shareService = inject(ShareService);
  shareLinkTextArea = viewChild('shareLinkTextArea', { read: ElementRef<HTMLTextAreaElement> });
  shouldShowCopyConfirmation = signal(false);
  shareLink = computed(() => this.shareService.shareLink());
  configuredItem = computed(() => this.selectedAttributeService.configuredItem());

  copyShareClicked() {
    this.clipBoard.copy(this.shareLink());

    if (this.googleAnalyticsService.isInitialized) {
      this.googleAnalyticsService.triggerEvent('click', 'copy_share', 'share_link_copy', this.shareLink());
    }
    (this.shareLinkTextArea()?.nativeElement as any)?.select();
    this.shouldShowCopyConfirmation.set(true);
  }

  shareURLFieldKeyDown(event: KeyboardEvent) {
    event.preventDefault();
  }

  closeButtonClicked() {
    this.navigationService.dismissAll();
  }
}
